import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { api, ApiError } from "../lib/api";

export function Login() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const client = useQueryClient();

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api("/api/auth/login", { json: { password } });

      // Quem chega pela raiz do domínio já passou pelo Guard uma vez, e o
      // `{authenticated:false}` daquela passagem ficou no cache. Sem esta linha o
      // `navigate()` abaixo remonta o Guard, que lê o valor velho antes do refetch
      // chegar e devolve a pessoa para cá — com o login tendo dado 204. Era o bug de
      // "tenho de tentar várias vezes num navegador novo": entrar por /login
      // funcionava de primeira, entrar pelo domínio não funcionava nunca.
      client.setQueryData(["session"], { authenticated: true });
      // As marcas de revisao viviam no localStorage do painel antigo. Migra
      // uma vez, sem apagar a origem: se algo der errado, o dado continua la.
      await migrateLocalMarks();
      navigate(params.get("next") || "/visao-geral", { replace: true });
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : "Falha ao entrar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login" onSubmit={submit}>
        <h1>Painel do Classificador</h1>
        <p>Categorização de transações. Acesso restrito.</p>
        <label htmlFor="senha">Senha</label>
        <input id="senha" type="password" value={password} autoFocus
               autoComplete="current-password"
               onChange={(e) => setPassword(e.target.value)} />
        {error && <p className="err" role="alert">{error}</p>}
        <button className="btn primary" disabled={busy || !password}>
          {busy ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}

async function migrateLocalMarks() {
  try {
    const migrated = localStorage.getItem("marcas-migradas");
    if (migrated) return;
    const byUser = new Map<string, { description: string; reviewed: boolean }[]>();
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key?.startsWith("onto-revisados:")) continue;
      const userId = key.slice("onto-revisados:".length);
      const value = JSON.parse(localStorage.getItem(key) || "[]");
      const list = Array.isArray(value) ? value : Object.keys(value ?? {});
      byUser.set(userId, list.map((d: string) => ({ description: d, reviewed: true })));
    }
    for (const [userId, items] of byUser) {
      if (items.length) {
        await api(`/api/review/${userId}/bulk`, { json: { items } });
      }
    }
    localStorage.setItem("marcas-migradas", new Date().toISOString());
  } catch {
    // Migracao e melhor-esforco: nunca deve impedir o login.
  }
}
